<template>
    <div>
        <b-modal
            id="modify-name-screening-hit-popup"
            ref="modal"
            title="Modify Name Screening Hit"
            size="sm"
            no-close-on-backdrop
            modal-class="hide-footer"
            hide-footer
            no-close-on-esc
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <div class="m-20">
                <p>Are you sure you want to mark this hit genuine?</p>
                <b-form-group>
                    <b-form-radio-group
                        v-model="selected"
                        v-validate="{ required: selected === null }"
                        :options="options"
                        name="genuine-hit"
                        :class="{
                            'is-invalid': errors.has('genuine-hit'),
                        }"
                    ></b-form-radio-group>
                </b-form-group>
            </div>
            <div class="col-md-12 action-buttons">
                <button
                    class="btn btn-primary"
                    type="submit"
                    :class="loading ? 'disabled' : ''"
                    @click="updateValue()"
                >
                    <span class="btn-text">Confirm</span>
                    <span class="loader"></span>
                </button>
                <button
                    class="btn btn-link"
                    type="button"
                    :disabled="loading"
                    @click="onHidden"
                >
                    <span class="btn-text">Close</span>
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'

export default {
    data() {
        return {
            id: null,
            selected: null,
            options: [
                { text: 'Yes', value: 'hit' },
                { text: 'No', value: '' },
            ],
        }
    },
    watch: {
        selectedItem(value) {
            this.selected = null
            if (value && value.hitDetermination != 'pending') {
                this.selected = value.hitDetermination
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(val) {
            if (val) {
                this.onHidden()
            }
        },
    }, // End of watch
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'success']),
    }, // End of computed

    methods: {
        async updateValue() {
            const result = await this.$validator.validateAll()
            //console.log(result, 'result')
            if (result) {
                let value = JSON.parse(JSON.stringify(this.selectedItem))
                value.hitDetermination = this.selected
                this.$set(
                    this.$parent.updatedDetails,
                    this.selectedItem.index,
                    value
                )
                this.onHidden()
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        },
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
    },
}
</script>
